import { aboutus_icon, impact_icon, lifeatutil_icon } from "../../helpers/constant/imageUrl";

export const ABOUTUS = [
  {
    img: aboutus_icon,
    text: "Our Story",
    path: "/aboutus/our-story",
  },
  {
    img: impact_icon,
    text: "Our Impact",
    path: "/aboutus/our-impact",
  },
  {
    img: lifeatutil_icon,
    text: "Life at Util",
    path: "/aboutus/life-at-util",
  },
  {
    img: "/images/partnerwithuslogo.webp",
    text: "Partners With Us",
    path: "/aboutus/partnerwithus",
  },
    {
    img: "/images/stories.png",
    text: "Sucess Stories",
    path: "/totalcards",
  },
];

export const DIRECT_CARDS = [
  {
    img: "/images/acard1.webp",
    alt: "Business customer connection",
    title: "We Help Businesses Connect with Customers Seamlessly",
    path: "/aboutus/our-story",
  },
  {
    img: "/images/acard2.webp",
    alt: "Stories insights success",
    title: "Stories, Insights & Success in Action",
    path: "/aboutus/our-impact",
  },{
    img: "/images/acard3.webp",
    alt: "Technology humanity",
    title: "Where Technology Meets Humanity",
    path: "/aboutus/life-at-util",
  },{
    img: "/images/acard4.webp",
    alt: "Salesforce partner services",
    title: "Grow your business by offering proven Salesforce services without building delivery from scratch.",
    path: "/aboutus/partnerwithus",
  },{
    img: "/images/acard5.webp",
    alt: "Purpose people culture",
    title: "Driven by Purpose. Defined by People.",
    path: "/aboutus/our-story",
  },{
    img: "/images/acard6.webp",
    alt: "Approach pledge target",
    title: "Our Approach, Pledge, Target",
    path: "/aboutus/our-impact",
  },{
    img: "/images/acard7.webp",
    alt: "Work purpose passion",
    title: "Work with Purpose. Live with Passion.",
    path: "/aboutus/life-at-util",
  },{
    img: "/images/acard8.webp",
    alt: "Partner value proposition",
    title: "The Partner Value Proposition",
    path: "/aboutus/partnerwithus",
  },
];